import React from "react";
import {Control} from "react-hook-form/dist/types";
import {Controller, FieldPath} from "react-hook-form";
import ComboBox, {ComboBoxProps} from "./ComboBox";
import {FieldValues} from "react-hook-form/dist/types/fields";
import {GiustificativoRecord} from "@commons/mapping/GiustificativoRecord";
import {RegisterOptions} from "react-hook-form/dist/types/validator";

/**
 * Componente per la selezione di un giustifcativo.
 * N.B. Il valore restituito a livello di form rappresenta unicamente il codice giustificativo, per prelevare invece l'intero oggetto valorizzare il metodo onChange
 * @param props
 * @constructor
 */
interface ComboBoxGiustificativoProps<T extends FieldValues> extends Pick<ComboBoxProps<T>, 'addOnBefore' | 'addOnAfter' | 'label' | 'inlineLabel' | 'disabled'> {
    control: Control<T>,
    name: FieldPath<T>,
    defaultValue: any,
    label: string,
    showLabel?: boolean,
    labelClassName?:string,
    data: GiustificativoRecord[] | undefined,
    isLoading?: boolean,
    onChange?: (v: GiustificativoRecord | null) => void,
    rules?: Omit<RegisterOptions<T, FieldPath<T>>, 'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'>,
    valueAsObject?: boolean
}

export function ComboBoxGiustificativo<T extends FieldValues>({showLabel = true, labelClassName='', ...props}: ComboBoxGiustificativoProps<T>) {
    return <Controller name={props.name}
                       control={props.control}
                       defaultValue={props.defaultValue}
                       rules={props.rules}
                       render={({field: {value, onChange}, fieldState}) => {
                           const val = props.valueAsObject ? value : {codGiu: value};

                           return <ComboBox<GiustificativoRecord> label={showLabel ? props.label : undefined} labelClassName={labelClassName} value={val} onChange={(value) => {
                               if (props.valueAsObject)
                                   onChange(value);
                               else
                                   onChange(value?.codGiu);
                               if (props.onChange)
                                   props.onChange(value);
                           }}
                                                                  data={props.data} isLoading={props.isLoading}
                                                                  searchablePropsName={["codGiu", "descrizione"]}
                                                                  fieldState={fieldState}
                                                                  isSameFn={(a, z) => (a && z) ? a.codGiu === z.codGiu : false}
                                                                  keyValueFn={(v) => v.codGiu!}
                                                                  displayValueFn={(v) => props.data && v ? `${v.descrizione} [#${v.codGiu}]` : ''}
                                                                  addOnBefore={props.addOnBefore}
                                                                  addOnAfter={props.addOnAfter}
                                                                  disabled={props.disabled}
                           />;
                       }}
    />
}